import React, { Fragment, useState, useEffect } from 'react';
import {
    Button,
    Row,
    Card,
    Input,
    ButtonGroup,
    CardBody,
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
export default function CustomCss({
    botSettings,
    saveIntegration,
}) {
    const [inputData, setInputData] = useState(
        {
            text: ""
        }
    );
    const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(
        botSettings?.customCss != null &&
        botSettings.customCss.isDisabled !== true
    );
    useEffect(() => {
        if (botSettings?.customCss) {
            setInputData({
                ...botSettings.customCss,
                text: botSettings.customCss.text || ""
            });

            setCheckedPrimarySmall(
                botSettings.customCss.isDisabled !== true
            );
        } else {
            setInputData({
                text: "",
                isDisabled: true
            });

            setCheckedPrimarySmall(false);
        }

        console.log("customCss:", botSettings?.customCss);
    }, [botSettings]);

    const handleTextChange = (e) => {
        setInputData({ ...inputData, text: e.target.value });
    }
    const handleSwitchChange = (value) => {
        setCheckedPrimarySmall(value);
        setInputData({
            ...inputData,
            isDisabled: !value
        });
    };
    const handleSave = () => {
        const updatedBotSettings = {
            ...botSettings,
            customCss: {
                ...inputData,
                isDisabled: !checkedPrimarySmall
            }
        };

        console.log("Saving botSettings:", updatedBotSettings);

        saveIntegration({
            botSetting: updatedBotSettings
        });
    };
    return (<Fragment>
        <Card className="mb-4">
            <CardBody name="bodyClick text-center">
                <div className="col-md-12 text-center">
                    <h6>Custom CSS</h6>
                    <p>Use CSS to customize the web widget layout</p>
                </div>
                <Separator className="mb-3" />
                <Card className="m-4 p-4">
                    <div className="mb-1 d-flex align-items-center">
                        <h6>Enabled</h6>
                        <Switch
                            className="custom-switch-primary custom-switch-small ml-2"
                            checked={checkedPrimarySmall}
                            onChange={(primary) => handleSwitchChange(primary)}
                        />
                    </div>
                    <div className="mb-1">
                        <span>
                            While most changes can be made with settings in,
                            you may prefer to use CSS to customize further if you have experience writing CSS code.
                        </span><br /><br />
                        <span className="ml-1"><b>Type or paste your CSS into the text box provided.</b></span>
                    </div>
                    <div className="mb-2">
                        <Input
                            type="textarea"
                            value={inputData.text}
                            name="text"
                            onChange={(e) => handleTextChange(e)}
                            style={{ height: "70px" }}
                        />
                    </div>
                </Card>
                <Separator className="mb-3" />
                <div className='d-flex justify-content-center mb-1'>
                    <Button color="primary" size="xs" onClick={handleSave}>
                        Save
                    </Button>
                </div>
            </CardBody>
        </Card>
    </Fragment >)
}